module.exports = __webpack_public_path__ + "img/smart-scan-4.8e3c235b.png";